import axiosNeuron from "api/axios";
import endpoints from "api/endpoints";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

type Params = {
  machineId: number;
  labelSubcategoryId: number;
  startDatetime: Date;
  endDatetime: Date;
};

dayjs.extend(utc);

export default async function interpolateRulLabels({
  machineId,
  labelSubcategoryId,
  startDatetime,
  endDatetime,
}: Params) {
  const url = endpoints.interpolateRulLabels;

  try {
    const response = await axiosNeuron.post(url, {
      machines: [machineId],
      label_subcategory: labelSubcategoryId,
      start_datetime: dayjs(startDatetime)
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
      end_datetime: dayjs(endDatetime)
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
    });
    return response;
  } catch (error) {
    if (error !== undefined) {
      throw error;
    }
  }
}
